module.exports = __webpack_public_path__ + "static/6-b7242b2f834eaecaba121521e094c26c.png";